// extracted by mini-css-extract-plugin
export default {"cell":"Time_cell__coL3N","editable":"Time_editable__NDip0"};